import React from "react";
import { useBreakpoints } from "../../hooks";

const DesktopTabletView: React.FC<React.PropsWithChildren<unknown>> = ({ children }) => {
  const { isDesktopTablet } = useBreakpoints();
  return isDesktopTablet ? <>{children}</> : null;
};

export default DesktopTabletView;
